import './app.css';
import { Fragment } from 'react';
import moduleName from 'echarts'
import {NavLink,BrowserRouter,Route} from 'react-router-dom'
import TotalMarket from './pages/totalmarket'
import ManRank from './pages/manrank'
import CategoryMarket from './pages/categorymarket'
import SegmentMarket from './pages/segmentmarket'
import CountryMarket from './pages/countrymarket'
import FuelMarket from './pages/fuelmarket'


// function ManRank(props){
// 	return (
// 		<div>
// 			ManRank
// 		</div>
// 	)
// }

// function CategoryMarket(props){
// 	return (
// 		<div>
// 			CategoryMarket
// 		</div>
// 	)
// }

// function CountryMarket(props){
// 	return (
// 		<div>
// 			CountryMarket
// 		</div>
// 	)
// }

// function SegmentMarket(props){
// 	return (
// 		<div>
// 			SegmentMarket
// 		</div>
// 	)
// }

// function FuelMarket(props){
// 	return (
// 		<div>
// 			FuelMarket
// 		</div>
// 	)
// }

function App() {
	return (
		<Fragment>			
			
				{/* <ul id="sub-nav">
					<li className="active">总体市场</li>
					<li>厂商销量</li>
					<li>车型大类</li>
					<li>国别细分市场</li>
					<li>级别细分市场</li>
					<li>新能源细分市场</li>
				</ul> */}
				<BrowserRouter>
					<div className="route">
						<NavLink activeClassName="active" to="/TotalMarket">总体市场</NavLink>
						<NavLink to="/ManRank">厂商销量</NavLink>
						<NavLink to="/CategoryMarket">车型大类</NavLink>
						<NavLink to="/CountryMarket">国别细分市场</NavLink>
						<NavLink to="/SegmentMarket">级别细分市场</NavLink>
						<NavLink to="/FuelMarket">新能源细分市场</NavLink>
					</div>
					<div className="chart_div" id="chart_container">
						<Route path="/TotalMarket" component={TotalMarket}></Route>
						<Route path="/" exact="true"  component={TotalMarket}></Route>
						<Route path="/ManRank" component={ManRank}></Route>					
						<Route path="/CategoryMarket" component={CategoryMarket}></Route>					
						<Route path="/CountryMarket" component={CountryMarket}></Route>					
						<Route path="/SegmentMarket" component={SegmentMarket}></Route>					
						<Route path="/FuelMarket" component={FuelMarket}></Route>					
					</div>
				</BrowserRouter>
			
			
				
		</Fragment>
	);
}

export default App;
